import type { EntityOption } from '@/components/EntitySelect';
import { createCabinetSkillCatalogEntry, getCabinetSkillCatalog } from './api';

/** Server search over the org skill catalog (EntitySelect). */
export async function searchCabinetSkills(query: string): Promise<EntityOption[]> {
  const skills = await getCabinetSkillCatalog(query || undefined);
  return skills.map((s) => ({ value: String(s.id), label: s.name }));
}

/** Free-text add: create (or reuse) a catalog skill from the typed name. */
export async function createCabinetSkillOption(name: string): Promise<EntityOption> {
  const skill = await createCabinetSkillCatalogEntry(name.trim());
  return { value: String(skill.id), label: skill.name };
}
